var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('content-title',{attrs:{"nav":_vm.nav}}),_c('classList',{ref:"classes",attrs:{"type":"manage"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }